
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"50","height":"50","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"25","cy":"25","r":"25","fill":"#98C1DD"}}),_c('path',{attrs:{"d":"M26.35 23.084c-1.27 0-2.117-.847-2.117-2.117s.847-2.117 2.117-2.117c.847 0 1.482.423 1.905 1.058.635 1.059 1.905 1.27 2.963.847 1.059-.635 1.27-1.905.847-2.963-.846-1.27-1.905-2.329-3.387-2.752v-.423c0-1.27-.846-2.117-2.116-2.117-1.482 0-2.329.847-2.329 2.117v.423c-2.54.847-4.233 3.175-4.233 5.927 0 3.598 2.752 6.35 6.35 6.35 1.27 0 2.117.846 2.117 2.117 0 1.27-.847 2.116-2.117 2.116-.847 0-1.482-.423-1.905-1.058-.635-1.058-1.905-1.27-2.963-.847-1.058.635-1.27 1.905-.847 2.964.847 1.27 1.905 2.328 3.387 2.751v.424c0 1.27.846 2.116 2.116 2.116s2.117-.846 2.117-2.116v-.424c2.54-.846 4.234-3.175 4.234-5.926.211-3.599-2.54-6.35-6.139-6.35z","fill":"#172542"}})])
          )
        }
      }
    